import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { AnimalScreeningReportVendors } from "shared/types";

interface ErrorSectionProps {
  vendor?: AnimalScreeningReportVendors;
  errorMessage?: string;
}

export const ErrorSection = ({ errorMessage, vendor }: ErrorSectionProps) => {
  const vendorText =
    vendor === AnimalScreeningReportVendors.OurPetPolicy
      ? "OurPetPolicy"
      : "PetScreening";
  return (
    <div className="flex flex-col h-full items-center justify-center">
      <div className="bg-danger-50 rounded-full p-4 flex items-center justify-center">
        <HugeiconsIcon
          icon={AlertCircleIcon}
          size={64}
          className="text-danger-500"
        />
      </div>
      <p className="text-lg text-content-400">
        Error retrieving animal screening report{" "}
        {vendor ? `from ${vendorText}` : ""}
      </p>
      <p className="text-sm text-content-400">{errorMessage}</p>
    </div>
  );
};
